<template>
  <div v-loading="loading">
    <div class="tableLayoutWrap" :class="{ tableWrapMargin: topDistance, isEmpty }">
      <!-- 数据区域兼容ele-table和a-table -->
      <!-- 适配el-table -->
      <div v-if="blmTableType === 'el-table'">
        <el-table
          v-if="loadmore"
          :max-height="maxHeight"
          :height="tableH"
          :data="tableSource"
          v-bind="$attrs"
          v-on="$listeners"
          v-loadmoreB="loadmore"
          ref="tableRef"
        >
          <slot></slot>
        </el-table>
        <el-table
          v-else
          :max-height="maxHeight"
          :height="tableH"
          :data="tableSource"
          v-bind="$attrs"
          v-on="$listeners"
          ref="tableRef"
        >
          <slot></slot>
        </el-table>
        <!-- 分页器区域 -->
        <BLMPagination
          v-if="!isEmpty&&pagination"
          :max-total="pagination.maxTotal"
          :page-num="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          :event="pagination.event"
          :layout="pagination.layout"
          :no-total="pagination.noTotal"
          :no-page-size="pagination.noPageSize"
          :order-paging="pagination.orderPaging"
          :smallBoolean="pagination.smallBoolean"
          :limitShowPages="pagination.limitShowPages"
          :pageSizes="pagination.pageSizes"
        >
        </BLMPagination>
      </div>

      <!-- 适配a-table -->
      <template v-else>
        <a-table
          :data-source="tableSource"
          :pagination="!isEmpty&&pagination"
          :scroll="aScroll"
          v-bind="$attrs"
          v-on="$listeners"
          ref="tableRef"
        >
          <div
            :slot="subTable ? 'expandedRowRender' : ''"
            key="expande"
            slot-scope="record"
          >
            <slot name="expandedRowRender" :record="record"></slot>
          </div>
          <slot></slot>
        </a-table>
      </template>

      <!-- 兜底空数据区域 -->
      <div v-if="isEmpty">
        <template v-if="$slots.empty">
          <slot name="empty"></slot>
        </template>
        <div v-else class="tableLayoutEmpty">
          <img src="../assets/empty_icon.png" alt="empty" />
          <span>{{emptyText}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * el-table适配参数
 *      通用参数参考el-table官网
 *      pagination：分页数据
 *      topDistance：支持头部距离，默认有
 *      blmTableType：表格类型，默认el-table
 *
 * a-table适配参数
 *      通用参数参考a-table官网
 *      topDistance：支持头部距离，默认有
 *      blmTableType：表格类型，默认el-table
 *      subTable：支持子表格(a-table适用)，默认不支持
 */

export default {
  name: 'BLMTable',
  directives: {
    loadmoreB: {
      bind(el, binding) {
        const selectWrap = el.querySelector('.el-table__body-wrapper')
        selectWrap.addEventListener('scroll', function () {
          const sign = 1
          const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
          if (scrollDistance <= sign && this.scrollTop) {
            binding.value()
          }
        })
      },
    },
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: [Object, Boolean],
      default: false,
    },
    topDistance: {
      type: Boolean,
      default: true,
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    blmTableType: {
      type: String,
      default: 'el-table',
    },
    subTable: {
      type: Boolean,
      default: false,
    },
    scroll: {
      type: Object,
    },
    height: {
      type: [Number, String],
    },
    maxHeight: {
      type: [Number, String],
      default: 'auto',
    },
    loadmore: {
      type: [Function, Object],
      default: null,
    },
    emptyText: {
      type: String,
      default: '没有更多数据了',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFirst: true,
    }
  },
  computed: {
    tableSource() {
      return this.blmTableType === 'a-table' ? this.dataSource : this.data
    },
    isEmpty() {
      // eslint-disable-next-line no-mixed-operators
      return !this.tableSource || this.tableSource && this.tableSource.length === 0
    },
    tableH() {
      return this.isEmpty ? 'auto' : this.height
    },
    aScroll() {
      let scroller = {
        x: true,
      }
      if (this.scroll) {
        scroller = this.scroll
      }
      if (this.maxHeight !== 'auto') { // maxHeight优先级更高
        scroller.y = this.maxHeight
      }
      return scroller
    },
  },
  watch: {
    data() {
      if (this.data && this.data.length > 0 && this.isFirst) {
        this.isFirst = false
        this.handleRef()
      }
    },
    dataSource() {
      if (this.dataSource && this.dataSource.length > 0 && this.isFirst) {
        this.isFirst = false
        this.handleRef()
      }
    },
  },
  mounted() {
    this.handleRef()
  },
  methods: {
    handleRef() {
      const _this = this
      this.$nextTick(() => {
        const refs = this.$parent.$refs
        for (const key in refs) {
          if (refs[key] && (refs[key].$el === _this.$el)) {
            refs[key] = this.$refs.tableRef
          }
        }
      })
    },
  },
}
</script>

<style scoped lang='scss'>
.tableLayoutWrap {
  &.isEmpty{
    //空表格时隐藏table自带的placeholder区域
    ::v-deep .el-table__body-wrapper{
      display: none;
    }
    ::v-deep .ant-table-placeholder{
      display: none;
    }
  }
  .tableLayoutEmpty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 160px;
    width: 100%;
    border: 1px solid #EBEDF0;
    border-top: 0;
    img {
      width: 64px;
      height: 42px;
      margin-bottom: 7px;
    }

    span {
      font-size: 14px;
      color: #969799;
      text-align: center;
      line-height: 22px;
    }
  }

  >>>a+a,>>>a+.el-button,>>>.el-button+a{
    margin-left: 10px;
  }

  .el-table--border {
    border-right: none;
    border-bottom: none;
    border-left: none;
  }
}

.tableWrapMargin {
  margin-top: 16px;
}
</style>
